export const NOTIFICATION = 'NOTIFICATION';
export const RESET_HEADER = 'RESET_HEADER';
export const SET_REPEAT_TOUR_ACTION = 'SET_REPEAT_TOUR_ACTION';


// WEBPACK FOOTER //
// ./source/client/actions/header/types.js